import { BigNumber } from "ethers";
import useAssets from "hooks/useAssets";
import useVesting from "hooks/useVesting";
import { useMemo } from "react";

const useHoneyInJars = (): Record<number, BigNumber> | undefined => {
  const { honeyJarsInWallet } = useAssets();
  const { vestingAmountInJarsRemaining } = useVesting();

  return useMemo(() => {
    if (honeyJarsInWallet && vestingAmountInJarsRemaining) {
      return honeyJarsInWallet.reduce(
        (prev, tokenId, index) => ({
          ...prev,
          [tokenId]: vestingAmountInJarsRemaining[index],
        }),
        {}
      );
    }
  }, [honeyJarsInWallet, vestingAmountInJarsRemaining]);
};

export default useHoneyInJars;
